import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import aakritiLogo from "@/assets/aakriti-logo.png";

// Shared split-screen wrapper for auth pages.
export default function AuthShell({ title, subtitle, children, testid }) {
  return (
    <div className="min-h-screen grid md:grid-cols-2 bg-background">
      <div className="hidden md:flex relative bg-primary text-white flex-col justify-between p-12 noise-overlay overflow-hidden">
        <div className="absolute -right-24 -top-24 w-96 h-96 rounded-full bg-accent/10 blur-3xl" />
        <Link to="/" className="flex items-center gap-2.5 relative z-10">
          <div className="h-10 rounded-md bg-white flex items-center justify-center px-1.5"><img src={aakritiLogo} alt="Aakriti" className="h-7 w-auto object-contain" /></div>
          <div className="font-display font-bold text-lg">Aakriti Associates</div>
        </Link>
        <div className="relative z-10">
          <h1 className="font-display font-black text-4xl lg:text-5xl leading-tight">Grow your valuation business.</h1>
          <p className="text-white/70 mt-4 max-w-md">Track every bank branch, follow-up, and valuation job in one place — and let your team deliver on time, every time.</p>
        </div>
        <div className="relative z-10 text-xs tracking-[0.2em] uppercase text-white/40">Raipur · Chhattisgarh</div>
      </div>
      <div className="flex items-center justify-center p-6">
        <div className="w-full max-w-sm" data-testid={testid}>
          <Link to="/login" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-primary mb-8 transition-colors" data-testid="back-to-login"><ArrowLeft size={16} /> Back to login</Link>
          <h2 className="font-display font-bold text-3xl text-primary">{title}</h2>
          {subtitle && <p className="text-muted-foreground mt-1 text-sm">{subtitle}</p>}
          <div className="mt-8">{children}</div>
        </div>
      </div>
    </div>
  );
}
